import { Fragment } from "react";
import { usePresenter } from "./context";
import { JoinCard } from "./JoinCard";
import { formatDate } from "./model";

/** "Agentic AI: where we are" breaks after the colon, as in the prototype. */
function titleLines(title: string): string[] {
  const i = title.indexOf(": ");
  return i > 0 ? [title.slice(0, i + 1), title.slice(i + 2)] : [title];
}

export function TitleSlide() {
  const { deck } = usePresenter().model;
  const eyebrow = [deck.event, formatDate(deck.date)].filter(Boolean).join(" · ").toUpperCase();
  return (
    <div className="slide title-slide">
      <div className="title-main">
        {eyebrow && <span className="title-eyebrow">{eyebrow}</span>}
        <span className="yellow-bar" />
        <h1 className="title-h">
          {titleLines(deck.title).map((line, i) => (
            <Fragment key={i}>
              {i > 0 && <br />}
              {line}
            </Fragment>
          ))}
        </h1>
        {deck.subtitle && <span className="title-lead">{deck.subtitle}</span>}
        {deck.presenter && <span className="title-presenter">{deck.presenter}</span>}
      </div>
      <JoinCard verb="Join" size="lg" />
    </div>
  );
}
